/**
 * Created by hj on 2017/8/16.
 */
import React from 'react';
import Reflux from 'reflux';
import { Button } from 'antd';
import { hashHistory, withRouter } from 'react-router';
import { DmsTab, TableView, FilterBox } from '../../components';
import { formatMoney, openNotice } from '../../utils/index.js';
import { getReturnOrderList } from '../../service/returnOrder';
import { allChildren } from '../../service/zone';
import { Store, Actions } from './store';
import moment from 'moment';

class ReturnOrderList extends Reflux.Component {
  constructor (props) {
    super(props);
    this.store = Reflux.initStore(Store); //创建一个Store实例
    this.state = {
      opts: ['全部订单', '待审核', '待客户发货', '待收货', '待发货', '待客户收货', '已完成'],
      key: 0,
      filterBoxVisible: false,
      rows: [],
      total: 1,
      searchObj: {
        code: '',
        customerName: '',
        createTimeStart: '',
        createTimeEnd: '',
        areaId: '',
        buyerStatus: '',
        orderType: '',
        s: 10,
        p: 1
      },
      regionOptions: [] /* 所属区域 */
    };
    this.pageChange = this.pageChange.bind(this);
    this.changeHandle = this.changeHandle.bind(this);
    this.visibleChange = this.visibleChange.bind(this);
    this.setFilterParam = this.setFilterParam.bind(this);
    this.advanceReset = this.advanceReset.bind(this);
    this.advanceSubmit = this.advanceSubmit.bind(this);
    this.routeLeaveHook = this.routeLeaveHook.bind(this);
  }

  goView (url) {
    hashHistory.push(url);
  }

  changeHandle ({ item, key, keyPath }) {
    let self = this;
    this.setState({
      key,
      searchObj: {
        ...this.state.searchObj,
        buyerStatus: key == 0 ? '' : key
      }
    }, function () {
      self.initData();
    });
  }

  visibleChange () {
    this.setState({ filterBoxVisible: !this.state.filterBoxVisible });
  }

  advanceReset () {
    let self = this;
    self.setState({
      searchObj: {
        ...this.state.searchObj,
        code: '',
        customerName: '',
        createTimeStart: '',
        createTimeEnd: '',
        areaId: '',
        buyerStatus: '',
        orderType: ''
      }
    }, function () {
      self.initData();
    });
  };

  advanceSubmit (form) {
    /* 筛选确认 */
    let self = this;
    self.setState({
      filterBoxVisible: false,
      searchObj: {
        ...this.state.searchObj,
        p: 1
      }
    }, function () {
      self.initData();
    });
  };

  setFilterParam (name, value) {
    if (name === 'orderTime') {
      this.setState({
        searchObj: {
          ...this.state.searchObj,
          createTimeStart: value.from,
          createTimeEnd: value.end
        }
      })
    } else {
      this.setState({ searchObj: { ...this.state.searchObj, [name]: value } })
    }
  };

  pageChange (page, pageSize) {
    let self = this;
    this.setState({ searchObj: { ...this.state.searchObj, s: pageSize, p: page } }, function () {
      self.initData();
    });
  }

  initData () {
    let self = this;
    let searchObj = this.state.searchObj;
    getReturnOrderList(searchObj).then(function (result) {
      if (result && result.code == 200) {
        self.setState({
          'rows': result.data || [],
          'total': result.total
        });
      } else {
        openNotice('error', '数据获取失败', '');
      }
    });
  }

  //离开当前路由时，更新store
  routeLeaveHook(nextLocation) {
    let path = nextLocation.pathname.split('/');
    if(path[1] === 'returnOrder'){ //当下一个路由是详情页时，将useStore的值设为true
      Actions.useStoreChange(true);
      Actions.paramChange(this.state.searchObj);
    }else{
      Actions.useStoreChange(false);
      Actions.paramChange({});
    }
  }

  componentWillMount () {
    let self = this;
    const data = this.store.state;
    if(data.useStore) { //根据useStore的值判断是否使用store中的数据
      this.setState({
        ...this.state,
        searchObj: {
          ...this.state.searchObj,
          ...data.params
        },
        key: data.params.buyerStatus || 0
      });
    }
    allChildren({id: 0}).then(result => { //归属区域
      if (result && result.code == '200') {
        self.setState({regionOptions: result.data || []});
      }
    });
  }

  componentDidMount () {
    this.initData();
    //设置离开当前路由时的钩子函数
    this.props.router.setRouteLeaveHook(this.props.route, this.routeLeaveHook);
  }

  render () {
    const { opts, key, filterBoxVisible, rows, total, searchObj, regionOptions } = this.state;
    const filterBoxProps = {
      showFlag: filterBoxVisible,
      advance: {
        fileds: [
          {
            name: 'orderType',
            label: '退换货类型',
            text: '选择退换货类型',
            options: [
              { value: '', text: '全部' },
              { value: '1', text: '退货' },
              { value: '2', text: '换货' },
            ],
            multiple: false,//支持多选
            type: 'select',
            defaultValue: searchObj.orderType
          },
          {
            name: 'code',
            label: '订单编码',
            text: '输入订单编码',
            type: 'default',
            defaultValue: searchObj.code
          },
          {
            name: 'customerName',
            label: '客户名称',
            text: '输入客户名称',
            type: 'default',
            defaultValue: searchObj.customerName
          },
          {
            name: 'orderTime',//createTimeStart, createTimeEnd
            label: '申请时间',
            options: [
              { text: '开始时间' },
              { text: '结束时间' },
            ],
            type: 'dateComp',
            defaultValue: {
              from: searchObj.createTimeStart || '',
              end: searchObj.createTimeEnd || ''
            },
          },
          {
            name: 'areaId',
            label: '订单所属区域',
            text: '请选择区域',
            type: 'treeSelect',
            options: regionOptions,
            defaultValue: searchObj.areaId
          }
        ],
        handle: this.advanceSubmit,
        reset: this.advanceReset,
        fieldHandle: this.setFilterParam
      }
    };
    const tableViewProps = {
      loading: false,//更新表格数据中
      rowKey: 'id',
      pageParam: {
        total,
        current: searchObj.p,//当前页码
        pageSize: searchObj.s,//当前分页数
        onChange: this.pageChange
      },
      columns: [
        {
          title: '退货编号',
          dataIndex: 'code',
          render: (text, record, index) => <a href={`#/returnOrder/${record.id}`}>{text}</a>
        }, {
          title: '申请时间',
          dataIndex: 'createdDate',
          render: text => <span>{moment(text).format('YYYY-MM-DD HH:mm:ss')}</span>
        }, {
          title: '客户',
          dataIndex: 'customerName'
        }, {
          title: '所属区域',
          dataIndex: 'areaText'
        }, {
          title: '订单金额(元)',
          dataIndex: 'amount',
          render: text => <span style={{ color: '#d61518' }}>{'¥' + formatMoney(text)}</span>
        }, {
          title: '类型',
          dataIndex: 'orderTypeText'
        }, {
          title: '订单状态',
          dataIndex: 'sellerStatusText'
        }, {
          title: '最后更新时间',
          dataIndex: 'lastUpdatedDate',
          render: text => <span>{moment(text).format('YYYY-MM-DD HH:mm:ss')}</span>
        }
      ],
      rows
    };
    return <div>
      <DmsTab options={opts} defaultKey={parseInt(key)} onChange={this.changeHandle}>
        <Button icon="filter" onClick={this.visibleChange}>筛选</Button>
        <FilterBox  {...filterBoxProps}/>
      </DmsTab>
      <div className="dms-table-box">
        <TableView {...tableViewProps}/>
      </div>
    </div>
  }
}
;
export default withRouter(ReturnOrderList);



// WEBPACK FOOTER //
// ./src/routes/returnOrder/list.js